import styled from 'styled-components';

import { fontSizes, fontWeights } from '../../theme';

export const Container = styled.div<{ $color: string }>`
  display: inline;
  margin: 0;
  font-size: ${fontSizes.l};
  font-weight: ${fontWeights.regular};
  color: ${({ $color }) => $color};
`;
